module.exports = __webpack_public_path__ + "img/hochzeit_paarfoto-auto_ocular.971e060a.jpg";